<template>
  <div>
  
    
    <b-row >
       
  <!----- SideBar All Design List ---->
   <div class="detailside">
     <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
   </div>
   <!-- <div class="side">
   <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
</div> -->
  <!----- SideBar All Design List End ----> 
  
     <div class="design-container-details__main" style="width:70%" >
        <div class="brand-card brandcard" >

          <div class="col-md-12 designtitle">
             <div class="col-md-12">Design Title:<strong> &nbsp;{{style_details.design_title}}</strong> </div>
              <div class="col-md-12">Style Name : &nbsp;{{style_details.style_name}} >> {{style_details.sub_cattitle}}</div>
              <div class="col-md-12">Created Date : {{style_details.created_date }} </div>
              <div class="col-md-12">Buyer Name : {{style_details.buyer_name }} </div>
          </div>
<navbarMenu></navbarMenu>
<br>



         <b-row class="detailsrow">
            
            <b-col cols="4" >
               <div class="divdesign" >
                  
                 <div class="col-md-3">
                      <div class="card-header" id="heading_data">
                        <div class="input-group"><h6>Online Users</h6>
                        </div>
                      </div>
                          <div class="card-body" id="contacts_body">
                          <ul class="contacts">
                          <li class="active">
                            <!-- @click="messagedisplay(user.vendor_id)" -->
                            <div class="d-flex bd-highlight" id="select_user" v-for="data in vendor_list" @click="messagedisplay(data.vendor_id)">
                              <div class="col-md-1 img_cont"><span class="online_icon icon1"><img  src="../assets/images/user.jpeg" class="rounded-circle user_img" ></span></div>
                              <!-- <div class="col-md-1"></div> -->
                              <div class="col-md-3" >{{data.vendor_name}}</div>
                            </div>
                          </li>
                          </ul>
                        </div>
                        <!-- <div class="card-footer msg-footer"></div> -->
                    </div>                 
               </div>

              
                  
              

            </b-col>
            <!-- <b-col cols="2"></b-col> -->

            <b-col cols="6" class="coldesign">
              
               
              <div  class='col-md-12 stylefield' >    

               <div class="card chat" >
                          <div class="card-header msg_head" id="headingdata">
                            <div class="d-flex bd-highlight" >
                              <div class="img_cont">
                                <img src="../assets/images/user.jpeg" class="rounded-circle user_img">
                                <span class="online_icon"></span>
                              </div>
                              <!-- <div class="user_info main_body_icon" >
                                <div class="selected_user" >
                                <span id="vendor_name"><label>{{}}</label></span>
                                <p>{{totalRows}} messages</p>
                                </div>
                              </div> -->
                            </div>
                          </div>
                          <div class="card-body" id="chatbody" >
                            <div class="d-flex justify-content-start mb-4" >
                              <table class="msg_body">
                                <tbody v-for="data in messagedata"  v-if="returnmsg_data==='Successful'">
                                  <div id="move" class="col-md-3">
                                <tr  v-if="data.message_by==1" style="background-color: #f5f5f5;">
                                  <td><div class=""><div class="vendor_msg"><img  src="../assets/images/user.jpeg" class="rounded-circle user_img_msg" id="vendor" >{{data.message}}</div></div></td>
                                </tr><tr v-if="data.message_by==1"><td class="msg_date"><div style="font-size: 8px;
    padding-left: 15px;">{{data.message_date}}</div></td></tr>
                              </div>
                              <div class="col-md-3"></div>
                              <div id="chat" class="col-md-3" >
                                <tr  v-if="data.message_by==0" style="background-color: #f5f5f5;">
                                  <td><div class=""><div class="admin_msg" ><img  style="float:right" src="../assets/images/fc.jpeg" class="rounded-circle user_img_msg">{{data.message}}</div></div></td>
                                </tr>
                                <tr v-if="data.message_by==0" style="background-color: #f5f5f5"><td style="font-size: 8px;
    padding-right: 15px; float:right;" class="msg_date">{{data.message_date}}</td></tr>
                              </div>
                                </tbody>

                                <!-- Else Part -->
                                <tbody  v-if="returnmsg_data==='Unsuccessful'">
                                <tr style="background-color: #f5f5f5">
                                  <td><div style="padding-left: 247px;padding-top: 200px;font-size:20px;">No Records Found</div></td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          

                          <div class="card-footer msg-footer">
                            <div class="input-group" > 
                              
                              <textarea id="txtName type_msg" v-model="txtInput"  class="form-control " placeholder="Type your message..."></textarea>
                              <div class="input-group-append">

                                <button type="submit" class="input-group-text send_btn  btn btn-primary" v-bind="txtInput" @click="onMessageSubmit(selected_vendor)"><i class="fa fa-send-o"></i></button>
                              </div>
                            </div>
                          </div>
                        </div>

              </div>  
               
            </b-col>
         </b-row>
          


</div>
</div>



 </b-row>    



   </div>


 
</template>

<script>

   import CONSTANTS from '@/utils/constants'
   import auth from '@/utils/auth'
   import Vue from 'vue'
   import Router from 'vue-router'
   //import {ImageMagnifier} from 'vue-image-magnifier'
   import ImageMagnifier from 'vue-image-magnifier'
   Vue.use(ImageMagnifier)
   import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
   import navbarMenu from './_navbarMenu.vue'
   
   const axios = require('axios')
   export default {
     name: 'Tabs',
     components: {
        sidebarAllDesignsComponent,
        navbarMenu
      },  

     data () {
       return {
         addfile:false,
         showSideMenu:true,
         tabs: [
           'Calculator',
           'Shopping cart',
           'Charts'
         ],
         quotationAddModal: false,
         msgRows: 0,
        style_details:[],
        quateitemlist:[],
        design_title:'',
        design_id:'',  
        design_date:'',   
        collection_title:'', 
        imgpath:'',
        totalRows: 0,
        quote_date :'',
        quote_quantity :'',
        quote_currency :'',
        quote_prce_per :'',
        price_per_garment : '',
        quote_status :'',
        quote_unit : '',
        quantity :[],
        visible : true,
          list: [],
          customer: {},
          messagedata: [],
          selectedId: 0,
          txtInput: '',
       title:'',
       design_no:'', 
       uploadfilemodel:false,
       activitylogsmodel: false,
        quote_tab:false,
        message_tab: false,
        files_list:[],
        nav_design_list :[],
        catselected: '',
        subcatselected:'',
        cat_title: '',
        sub_cat_title:'',

        file_title:'',
        file_category:'',
        file_url_path:'',
        file_Category_options: [
          
          { value: 'Technical Pack', text: 'Technical Pack' },
          { value: 'Fabric', text: 'Fabric' },
          { value: 'Constructions', text: 'Constructions' },
          
        ],

        no_of_unit:[
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' }
        ],
        color_family:[],

        //Code for sampling
        requestSampleModal: false,
        // requestedlisting:[],

        selectedDate: new Date(),
        // items:[],
        result:[],
        sample_data: [],
        //Sampling code ends

        colortype: {},
          customer: {},
           colorcode:{},
            color_name:[],
          color_family:[],
           pantoncolor: [],
           showhexcolor:'',
            pantonno_result:[],
            showcolorname:'',
            SelectPantonType:'',
           

      quoteunit: [
        { value: 'INR', text: 'INR' }
        
      ],
   
         activeTab: 1,

         //New Added Code
         editdesign: false,
         design_categoty_id: 0,
         design_subcategoty_id: 0,
         updated_by:'',
         segment_id: 0,
         utility_type_arr: [],
         no_of_units_in_pack: 0,
         no_of_colors: 0,
         no_of_size_sets: 0,
         style_image:'',
         file:'',
         po_typearr: [],
         sub_cat: [],
         selectedPO_type: null,
         selected_sub_category: null,
         selected:'',
         route_id: '',
         addcommentModel: false,
         activitylogModel:  false,
         comment: '',
         status: '',
         user_type: '',
         temp_color: '',
         temp_style_name: '',
         temp_style_image: '',
         temp_style_description:'',
         flag: 0,
         img_data: '',
         temp_sizeset : 0,
         tp_status: false,   
         measurementchart_status: false,
         bom_status: false,
         fileupload_status: false,
         openimagemodel: false,
         opentablemodel:false,
         //name:"design_details",
         name:"auth",
         component_name: 'design_details',
         uploadedfile: '',
         chnaged_image: false,
         selected_draft_value: 0,
         remoteUrl: '',
         temp_file: '',
         progress:0,
         no_of_sizeset:[
        { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' },
          { value: '11', text: '11' },
          { value: '12', text: '12' },
          { value: '13', text: '13' },
          { value: '14', text: '14' },
          { value: '15', text: '15' },
          { value: '16', text: '16' },
          { value: '17', text: '17' },
          { value: '18', text: '18' },
          { value: '19', text: '19' },
          { value: '20', text: '20' }
        ],
// ,tdClass: 'nameOfTheClass' tdClass: 'viewClass'
        fields1: [
            { key: 'operation_name', label: 'Operation Name' },
            // { key: 'status', label: 'Status'},
            { key: 'time', label: 'Time'},
            { key: 'time_stamp', label: 'Time Stamp'},
            { key: 'initiated_by', label: 'Event Initiated By'},
            { key: 'view_details', label: 'View Details'}
         
      
       ],
       vendors_fields: [
            //{ key: 'selected', label: 'Selected'},tdClass: 'nameOfTheClass'sortable: true, sortDirection: 'desc' 
          { key: 'vendor_name', label: 'Vendor Name' },
          { key: 'quantity', label: 'Quantity'},
           { key: 'target_price', label: 'Target Price'},
            { key: 'updated_date', label: 'Request Date' },
            { key: 'effective_date', label: 'Submitted Date'},
            { key: 'status', label: 'Status'},
      
       ],
       style_activity:[],
       bordered: true,
       activitydetailsModel: false,
       selected_old_value: '',
       selected_new_value: '',
       selected_style_action: '',
       selected_status_code_number: 0,
       vendors_items: [],
       quotation_count: 0,
       quotationlistModel: false,
       isBusy: false,
       perPage:  10,
      currentPage: 1,
      sizeset: [],
      invoice_products:[{
              unit: [],
              selectedfromage: [],
              selectedtoage: [],
            }
          ],
      //   invoice_products:[{
      //   unit: [],
      //   selectedfromage: [],
      //   selectedtoage: [],
      //   quantity: [],
      //   factorysize: [],
      // }
      //   ],
        selected_month: [],
        selected_age: 0,
        selectedfromage:[],
        selectedtoage: [],
        month_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],      
          year_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' }          
              ],
          to_month_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],      
          to_year_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' }          
              ],
          agefrmto_default: [
          { value: '', text: '-- Select --' }
          
          ], 
          factorysize: [],
          unit_arr: [
          { value: '0', text: 'Month' },
          { value: '1', text: 'Year' }
          ],
          index:1,
          age_from: [],
          //age_to: [],
          age_to: [],
          total_quantity: 0,
          sizesetselect: false,
          tbl_selected_month:[],
          tbl_selectedfromage:[],
          tbl_selectedtoage:[],
          tbl_invoice_products:[{
            tbl_unit: [],
            tbl_selectedfromage: [],
            tbl_selectedtoage: [],
            tbl_factorysize: [],
            tbl_quantity: [],
          }
            ],

            tbl_unit: [],
            tbl_selectedfromage: [],
            tbl_selectedtoage: [],
            tbl_factorysize: [],
            tbl_quantity:[],
            selected_color_family: '',
          temp_selected_color_family: '',
          selected_pantone_no: '',
          selected_panton_type: '',
          temp_selected_panton_type: '',
          temp_selected_pantone_no: '',

          selected_color: '',
          selected_final_color: '',
          selected:'',
         //file_tab_status: false,
         //New Added Code Ends

         //Addd Code
         style_details: [],
        route_id: '',
        user_type: '',
        isBusy: false,
        result: [],
        file_tab_status: false,
        visible : true,
        list: [],
        customer: {},
        messagedata: [],
        selectedId: 0,
        txtInput: '',
        totalRows: 0,
        vendor_list: [],
        selected_brand_id: 0,
        selected_vendor: 0,
        returnmsg_data:'',
         //Added Code Ends
       }
     },
     created: function() { 
      var userData = localStorage.getItem('userData')
        var userInfo = JSON.parse(userData)
        
      this.route_id=this.$route.params.id; 
      this.displayvendorlist();
      this.getdesigndetail();
      this.getvendorlist();
      this.getdesigndetail();
      this.getcolorfamilylist();
      this.route_id=this.$route.params.id;
      // var userData = localStorage.getItem('userData');
      // var userInfo = JSON.parse(userData);
      // this.user_type = userInfo[0].user_type;
      this.messagedisplay();
      this.user_type = userInfo[0].user_type;
     

     },
     mounted() {
      },
       methods: {
    //     finalcoloroutput: function(value){
    //   if(value==1){
    //   document.getElementById('final_color_output').style.display="block";
    // }
    // else{
    //   this.style_details.pantone_no='';
    //   this.style_details.color_family='';
    //   document.getElementById('final_color_output').style.display="none";
    // }
    // },
     finalcoloroutput: function(value){
      // alert("Innnnnn")
      if(value==1){
      document.getElementById('final_color_output').style.display="block";
    }
    else{
      
      document.getElementById('final_color_output').style.display="none";
    }
    },
    colortypecheck: function(value){
      // this.selected_pantone_no='';
      // this.setSelectedcolor(value);
      this.colorcheck=value;
      if(value!='OTHERS' && value!=''){
        document.getElementById('other_value_block').style.display="none";
        document.getElementById('pantom_color_block').style.display="block";
      }
      else{
       // this.selected_pantone_no='';
       // this.setSelectedcolor(value);

        if(value=='OTHERS'){
          document.getElementById('other_value_block').style.display="block";
         document.getElementById('pantom_color_block').style.display="none";
        }
       
      }
    },
   
      opensizesetdata: function(value){
        // alert(value)
        this.sizeset=[];
        for(var i=1;i<=value;i++){
          // alert("In")
          this.sizeset.push(i);
        }
       console.log(":::::::::::::::::::::::::::",this.sizeset)
        
      },



        // Change Drop Down Value for Month & Year By Prasad
      changeMonthYearVal: function(value_for,index)
      {

        if(value_for==0) //month
        {
        //this.age_from[index] ="";
        this.age_from[index] = this.year_arr;
          this.selectedfromage[index]= this.year_arr;
        }
        else
        {
           this.age_from[index] = this.month_arr;
          this.selectedfromage[index]= this.year_arr;
        }
        
      },

      showactivitydetails(value){
        this.selected_old_value= value.old_value;
        this.selected_new_value= value.new_value;
        this.selected_style_action= value.style_action;
        console.log("IIIIIIIIIIIIIIIII",value);
        this.activitydetailsModel = !this.activitydetailsModel;
      },

    quotationlistModelcancel: function(){
      this.quotationlistModel= false;
    },

      getStyleActivityLog(){
      const Obj={
            style_id:this.$route.params.id
   
      }
      axios.post(`${CONSTANTS.API_URL}/getStyleActivityLog`,Obj)
       .then(response => {
        console.log("**********************",response);
        if(response.data.returnmsg=='Successful')
        {
          this.style_activity = response.data.returnvalue;
          this.activitylogModel= true;
        }
        else{
          this.style_activity= response.data.returnvalue;
          this.activitylogModel= true;
        }
        
        
      }).catch((err) =>{
          return new Error(err.message);
        })

    },
    //Panton Color
    getcolorfamilylist: function(value) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     
      const Obj ={"color_type":"TCX"}
      axios.post(`${CONSTANTS.API_URL}/getcolorfamilylist`,Obj)
        .then((result) => {
          if (result.data.returnmsg === 'Successful') {
            this.color_family  = result.data.returnvalue;
          }else {
           this.color_family =[];
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    },
    getselectedfamilycolor: function(color) {
          const Obj = {
      color_family: color
      }
      this.temp_selected_panton_type=color;
      axios.post(`${CONSTANTS.API_URL}/getlistagainstcolorfamily`, Obj)
        .then((result) => {
          this.result1 = result.data
          if (this.result1.returnmsg === 'Successful') {
            this.color_name  = this.result1.returnvalue;
            var data = [];
 
              this.color_name.forEach(function (srData) {
                data.push({
                  key:srData.pantone_no,
                  label:srData.color_name+ ' - '+srData.pantone_no
                });
              });
              console.log("OOOOOOOOOOOOOOOOOOOOOO",data)
              this.color_name = data;
          }else {
           this.color_name =[];
          }

          
        }) 
    },
    setSelectedcolor: function(value, checked_val) 

    {
      
      // var x=document.getElementById('opt').style.backgroundColor=opt.value;
      // .style.backgroundColor=colorData;
      // document.body.style.backgroundColor =  colorData;
      
      // var colorData='12-6204 TCX'

      if(checked_val==0){
      var Obj = {
      pantone_no: value
      }
      }
      else{
        var Obj = {
      pantone_no: value.key
      }
      }
console.log("OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO",Obj)
      axios.post(`${CONSTANTS.API_URL}/getlistagainstpantonno`, Obj)
        .then((result) => {
          this.pantonno_result = result.data
          if (this.pantonno_result.returnmsg === 'Successful') {
            this.pantoncolor  = this.pantonno_result.returnvalue;
            this.showhexcolor=this.pantoncolor[0].hex_code;
            var temp_hex=this.pantoncolor[0].hex_code;
            this.showcolorname=this.pantoncolor[0].color_name;
            console.log("CCCCCCCCCCCCCCCCCCCCCCCCCC",this.showcolorname);
            var temp_colorname=this.pantoncolor[0].color_name;
            this.selected_final_color= this.showcolorname+ " "+this.showhexcolor
            if(checked_val==0){
              this.temp_selected_pantone_no=value;
            }
            else{
              this.temp_selected_pantone_no=value.key;
            }
            document.getElementById("showcolor").style.backgroundColor =this.showhexcolor;
             document.getElementById("showcolor").innerHTML=this.showcolorname+ " - " +this.showhexcolor;
            document.getElementById("showcolor1").style.backgroundColor =temp_hex;
             document.getElementById("showcolor1").innerHTML=temp_colorname+ " - " +this.showhexcolor;

          }else {
           this.pantoncolor =[];
          }    
        })   
    },

    vendorsquotesdetails(){
      document.getElementById("overlay").style.display = "block";
       var userData = localStorage.getItem('userData');
      // if (userData) 
      // {
           var userInfo = JSON.parse(userData)
           this.vendor_id = userInfo[0].vendor_id; 

        
           const Obj = {
                style_id:this.$route.params.id
              }
           axios.post(`${CONSTANTS.API_URL}/getqutationdetails`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             // JSON responses are automatically parsed.
             this.result = response.data
             this.quotationlistModel= true;
             if (this.result.returnmsg === 'Successful') {
               this.vendors_items = this.result.returnvalue;
               this.isBusy = false;
               // this.totalRows = this.result.returnvalue.length;
               this.quotation_count = this.result.returnvalue.length;
               // for(var i=0;i<=this.quotation_count;i++)
               // {
               //    if(this.items[i].status=='Approved'){
               //      this.selected_status = 'Approved'
               //    }
               // }
              

               
             }else {
              this.vendors_items =[];
              this.isBusy = false;
              this.quotation_count=0;
              this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
    },


        zoomin: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth >= 2500) return false;
         else{
            myImg.style.width = (currWidth + 100) + "px";
        } 
    },
    zoomout: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth <= 270) return false;
     else{
            myImg.style.width = (currWidth - 100) + "px";
        }
    },
    openimage:function(){
      this.openimagemodel = !this.openimagemodel;
    },
        openimagecancel: function(){
      this.openimagemodel = !this.openimagemodel;
     },
       openNav:function(){
      var opennav=document.getElementById("myNav").style.width = "25%";
     },
     closeNav:function(){
      var closenav=document.getElementById("myNav").style.width = "0%";
     },

    // validateForm4(scope) {
    //   this.$validator.validateAll(scope).then(result => {
    //     if (result) {
    //       alert("1st");
    //        this.updatestyle();
    //     }
    //   });
    // },

    /****** Function to add design image ********/
      AddDesignimage(event){
         this.uploadedfile = event.target.files[0];
         this.chnaged_image= true;
      },
      /****** Function to add design image ends ********/

    //Update Collection Code

     updatestyle(event,value,unit,from_age,to_age,index){
      console.log("**************************",from_age)
      document.getElementById("overlay").style.display = "block";
      
      this.invoice_products=[{
        unit: [],
        selectedfromage: [],
        selectedtoage: [],
      }
        ];
    
      
      if(this.sizeset.length<=from_age.length && this.sizeset.length<=to_age.length && this.sizeset.length<=unit.length){
       for(var i=0;i<=this.style_details.no_of_sizeset; i++){

            this.invoice_products[0].unit.push(unit);
            this.invoice_products[0].selectedfromage.push(from_age);
            this.invoice_products[0].selectedtoage.push(to_age);

          }
          console.log("SSSSSSSSSSSSSSSSSSSSSSSS",this.invoice_products)
      
      // var main_arr=[];
      //   if(this.temp_sizeset==this.style_details.no_of_sizeset){
      //   main_arr.push(this.style_details.size_details);
      //   }
      //   else{
      //   main_arr.push(this.invoice_products[0])
      //   }
             
      this.selected_draft_value= value;
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      var temp_from_age=this.invoice_products[0].selectedfromage;
        var temp_to_age=this.invoice_products[0].selectedtoage;
        var check_val=0;
       
        var main_arr=[];
        main_arr.push(this.invoice_products[0])
        for(var i=0; i<temp_from_age.length;i++)
        {
         
          if(parseInt(temp_from_age[i]) > parseInt(temp_to_age[i]))
          {

            // alert("Size "+ parseInt(i+ 1) +" Position 'Age To' Value Should Be Greater Than Or Equal To 'Age From' Value");
             this.$fire({
                 text:"Size "+ parseInt(i+ 1) +" Position 'Age To' Value Should Be Greater Than Or Equal To 'Age From' Value",
                 type: "warning",
                 timer: 30000
                        })
            check_val=0;
            
            document.getElementById("overlay").style.display = "none";
            return false;

          }
          else
          {
           
            check_val=check_val+1;
            
          }
        }

       
        if(check_val==temp_from_age.length){
       if(this.temp_color!=this.style_details.color || this.temp_style_name!=this.style_details.style_name || this.temp_sizeset!=this.style_details.no_of_sizeset){
          this.flag = 1;
        }
       
        else if(this.temp_color==this.style_details.color ||this.temp_style_description!=this.style_details.style_description || this.temp_style_name==this.style_details.style_name || this.temp_sizeset==this.style_details.no_of_sizeset || this.temp_style_image!= this.style_details.style_image){
          this.flag = 0;
        }
        // if(file.type=='image/jpeg' || file.type=='image/png'){

        // const Obj=
        //   {
        //     style_id:this.$route.params.id,
        //     style_name:this.style_details.style_name,
        //     updated_by:userInfo[0].email_id,
        //     color:this.style_details.color,
        //     no_of_sizeset:this.style_details.no_of_sizeset,
        //     style_description: this.style_details.style_description,
        //     flag : this.flag,
        //     }
        let data = new FormData();
        let config = {
            header : {
             'Content-Type' : 'multipart/form-data'
           }
          }
          

        if(this.temp_file!= undefined){
          data.append('file', this.temp_file)
          data.append('style_id',this.$route.params.id)
          data.append('style_name', this.style_details.style_name)
          data.append('updated_by', userInfo[0].email_id)
          if(this.temp_selected_panton_type=='OTHERS'){
            data.append('color', this.style_details.color)
          }
          else
          {
            data.append('color', this.selected_final_color)
          }
          data.append('no_of_sizeset', this.style_details.no_of_sizeset)
          data.append('style_description', this.style_details.style_description)
          data.append('brand_id', this.style_details.brand_id)
          data.append('flag', this.flag)
          data.append('is_draft', this.selected_draft_value)
          data.append('size_details',JSON.stringify(main_arr))
          data.append('brand_manager', userInfo[0].brand_manager)
          data.append('pantone_no',this.temp_selected_pantone_no)
          data.append('panton_type',this.temp_selected_panton_type)
          
        }
        else{
          
          //let file = event.target.files[0];
          data.append('file', '')
          data.append('style_id',this.$route.params.id)
          data.append('style_name', this.style_details.style_name)
          data.append('updated_by', userInfo[0].email_id)
          if(this.temp_selected_panton_type=='OTHERS'){
            data.append('color', this.style_details.color)
          }
          else
          {
            data.append('color', this.temp_selected_pantone_no)
          }
          data.append('no_of_sizeset', this.style_details.no_of_sizeset)
          data.append('style_description', this.style_details.style_description)
          data.append('brand_id', this.style_details.brand_id)
          data.append('flag', this.flag)
          data.append('size_details',JSON.stringify(main_arr))
          data.append('is_draft', this.selected_draft_value)
          data.append('pantone_no',this.temp_selected_pantone_no)
          data.append('panton_type',this.temp_selected_panton_type)
          // let config = {
          //   header : {
          //    'Content-Type' : 'multipart/form-data'
          //  }
          // }
        }
        console.log("CCCCCCCCCCCCCCCCCCCCCCCCCCCCc",main_arr)
        // return false;
        axios.post(`${CONSTANTS.API_URL}/updatestyle`,data, config)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {
            // this.getdesigndetail();
            // alert("Updated Successfully", "success");
            this.sizeset=[];
            this.$fire({
                text:"Updated Successfully.",
                type: "success",
                timer: 30000
                      })
            this.editdesign = !this.editdesign;
            this.customer = {};
            this.invoice_products=[{
              unit: [],
              selectedfromage: [],
              selectedtoage: [],
            }
              ];
            this.getdesigndetail();
            
          }else {
           // alert(this.result.returnvalue);
            this.$fire({
                text:this.result.returnvalue,
                type: "error",
                timer: 30000
                      })
          }


        })

        .catch(e => {
          this.errors.push(e)
        })

    }
    
    }
    else{
      document.getElementById("overlay").style.display = "none";
      this.$fire({
                 text:"Please Select All Size Set.",
                 type: "warning",
                 timer: 100000
                        })
    }
    },  
    //Update Collection Code Ends


    editdesigncancel: function() {
      this.customer = {};
      this.editdesign = !this.editdesign;
    },

    activitylogcancel: function() {
      this.customer = {};
      this.activitylogModel = !this.activitylogModel;
    },
    activitydetailscancel: function(){
    this.activitydetailsModel = !this.activitydetailsModel;
    },
    commentcancel: function(){
      this.customer = {};
      this.addcommentModel = !this.addcommentModel;
    },

        //Code Added by Sachin
        //Code for Edit Design
    changedesign: function(value) {      
      this.editdesign = !this.editdesign;
    },

     activitylog: function(value) {      
      this.activitylogModel = !this.activitylogModel;
    },
        //Code End For Edit Design
    addcomment: function(value) {  
      this.comment='';
      this.status='';    
      this.addcommentModel = !this.addcommentModel;
    },


    upload(event){
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      // let file = event.target.files[0];
      data.append('file', this.uploadedfile)
      data.append('style_id',this.$route.params.id)
      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }
      
      if(this.uploadedfile.type=='image/jpeg' || this.uploadedfile.type=='image/png'){

      axios.post(`${CONSTANTS.API_URL}/uploaddesignimage`,data, config)
       .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.style_image = response.data.url;
        this.style_details.style_image=this.style_image;
      }).catch((err) =>{
          return new Error(err.message);
        })
    }
    else{
      // alert("Please Select JPG or PNG Format Image Only");
       this.$fire({
                text:"Please Select JPG or PNG Format Image Only.",
                type: "warning",
                timer: 30000
                      })
      this.style_image = '';
      this.uploadedfile='';
    }

    },
    //new ends 
     //Table Set Function
       opentable:function(){
           this.opentablemodel=!this.opentablemodel;
       },
       opentablecancel:function(){
           this.opentablemodel=!this.opentablemodel;
       },

    uploadImage(imgname,imgtype){

      const { image } = this;
      const Obj={
            style_id:this.$route.params.id,
            style_image:image 
   
      }
      axios.post(`${CONSTANTS.API_URL}/uploaddesignimage`,Obj)
       .then(response => {
        this.style_image = response.data.url;
        
        this.style_details.style_image=this.style_image;
      }).catch((err) =>{
          return new Error(err.message);
        })

    },

    removeImage: function (e) {
      this.upload_image = '';
    },
  //Code for Image Ends 
        //Code Ends
        //Code Ends

        //code for preview image
      previewImage(imgdata){
        document.getElementById("progress_bar").style.display = "block";
        this.temp_file=event.target.files[0];
        this.progress=0;
        this.uploadedfile = event.target.files[0];
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      // let file = event.target.files[0];
      data.append('file', this.uploadedfile)
      data.append('user_id',userInfo[0].user_id)
      data.append('design_id',this.$route.params.id)
      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }

      //code for progressbar
      this.progress=0
      this.currentFile=this.uploadedfile;
      //code for progressbar
      document.getElementById("overlay").style.display = "block";
      if(this.uploadedfile.type=='image/jpeg' || this.uploadedfile.type=='image/png'){

      axios.post(`${CONSTANTS.API_URL}/previewselectedimage`,data, {header : {
         'Content-Type' : 'multipart/form-data'
       }, 
       onUploadProgress:function(progressEvent){
          this.progress=Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }.bind(this)
       }).then(response => {
        this.progress = Math.round((100 * response.loaded) / response.total);
        document.getElementById("overlay").style.display = "none";
        this.uploadedfile = response.data.url;
        // alert("File Uploaded Successfully");
        this.$fire({
                text:"File Uploaded Successfully.",
                type: "success",
                timer: 30000
                      })
        document.getElementById("progress_bar").style.display = "none";
      }).catch((err) =>{
          return new Error(err.message);
          this.progress=0;
          this.message="Could not upload the file!";
          this.currentFile='';
        })
    }
    },
        //code for preview image ends

        // Function For Action on status
    updatestylestatus: function(comment,value) {
      document.getElementById("overlay").style.display = "block";
      var status = value;
      var comment = comment;
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id; 
           
       if(status!=''){         
      const Obj={
        operational_status: status,
        updated_by: userInfo[0].email_id,
        user_id: userInfo[0].user_id,
        style_id: this.route_id,
        comments : comment
      } 
      axios.post(`${CONSTANTS.API_URL}/updatestylestatus`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data
        if (this.result.returnmsg === 'Successful') {
          // alert("Status Updated Successfully");
          this.$fire({
                text:"Status Updated Successfully.",
                type: "success",
                timer: 30000
                      })
          this.addcommentModel= false;
          // this.sizeset=[];
          this.router.go(0);
          this.getdesigndetail();
        }else {
         // alert("Please Check Status");
          this.$fire({
                text:"Please Check Status",
                type: "warning",
                timer: 90000
                      })
          
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    }
      else{
      document.getElementById("overlay").style.display = "none";
      this.$fire({
                text:"Please Check Status",
                type: "warning",
                timer: 900000
                      })
    }
    },

   
       /****** Function to design details ********/
       getdesigndetail: function () {
        var userData = localStorage.getItem('userData')
        var userInfo = JSON.parse(userData)
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Origin']='http://localhost:8080';
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,              
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
             
            this.style_details  = this.result.returnvalue[0];
            this.uploadedfile = this.style_details.style_image;
            this.selected_color_family= this.style_details.color_family;
            this.selected_pantone_no= this.style_details.pantone_no;
            this.selected_panton_type= this.style_details.panton_type;
            this.temp_color=this.style_details.color; 
            this.temp_sizeset=this.style_details.no_of_sizeset;
            // this.sizeset=this.style_details.no_of_sizeset;
            this.selected_design_id = this.style_details.design_id;
             this.getDesignSampleList(this.selected_design_id)

            for(var i=1;i<=this.style_details.no_of_sizeset;i++){
              this.sizeset.push(i);
              // alert("In")
            }
            console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT",this.sizeset)
            this.temp_style_description=this.style_details.style_description;
            this.temp_style_name = this.style_details.style_name;
            this.temp_style_image = this.style_details.style_image;

            this.fileObj_msg = this.result.returnvalue[1].file_name;

            this.selected_status_code_number = this.style_details.status_code_number;
            this.totalRows = this.result.returnvalue.length;

            // console.log("########################",this.style_details.size_details[0].quantity[0])
             // alert("kkkkkk1111");

            console.log("{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{",this.style_details.pantone_no)
            this.getselectedfamilycolor(this.selected_panton_type);
            this.setSelectedcolor(this.style_details.pantone_no,0);
            var temp_selected_unit= this.style_details.size_details[0].unit[0];
            var temp_selected_fromage= this.style_details.size_details[0].selectedfromage[0];
            var temp_selected_toage=this.style_details.size_details[0].selectedtoage[0];

            
       
               for( var i =0 ; i<this.style_details.size_details[0].selectedfromage[0].length;i++){

                this.selected_month[i]=temp_selected_unit[i];
                this.selectedfromage[i]=temp_selected_fromage[i];
                this.selectedtoage[i]= temp_selected_toage[i];

               }   
               console.log("11111111111111111111111111111111this.selected_month",this.selected_month);
            if(this.style_details.status_code_number>=12 && this.style_details.status_code_number!=13){
              var temp_factorysize= this.style_details.size_details[0].factorysize[0];
            }
            if(this.style_details.status_code_number>=15 ){

              var temp_qty= this.style_details.size_details[0].quantity[0];
            }
            
            for( var i =0 ; i<this.style_details.size_details[0].selectedfromage[0].length;i++){
                this.tbl_selected_month[i]=temp_selected_unit[i];
                this.tbl_selectedfromage[i]=temp_selected_fromage[i];
                this.tbl_selectedtoage[i]= temp_selected_toage[i];
                if(this.style_details.status_code_number>=12 && this.style_details.status_code_number!=13){
                  this.tbl_factorysize[i]= temp_factorysize[i];
                }
                 if(this.style_details.status_code_number>=15){

                  this.tbl_quantity[i]= temp_qty[i];
               
                }
                // this.quantity[i]= temp_qty[i];
                // this.factorysize[i]= temp_factorysize[i];
               }  
              
              
            
            this.totalRows = this.result.returnvalue.length;                
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           // .catch(e => {
           //   this.errors.push(e)
           // })
   
   
       },

         /****** Function to Get Design Sample List ********/
        getDesignSampleList: function (value) {

        this.isBusy = true;
        const Obj={
          "design_id":value
        }

        axios.post(`${CONSTANTS.API_URL}/getstylesamplelist`,Obj)
        .then(response => {
          // JSON responses are automatically parsed.
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {

            this.nav_design_list  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;

            
            this.isBusy = !this.isBusy;
            
          }else {
           this.design_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


        },


        /****** Function to design summary ********/
       getfileslisting: function () {
   
           this.isBusy = true;
           const Obj = {
                design_id:  this.$route.params.id,
              
              }
          
           axios.post(`${CONSTANTS.API_URL}/getdesignfilelist `,Obj)
           .then(response => {
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
   
               this.files_list = this.result.returnvalue;
               this.totalRows = this.result.returnvalue.length;
   
               
               this.isBusy = !this.isBusy;
               
             }else {
              this.files_list =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },



       //Added Message Code
       getvendorlist: function(){
          var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var recarr=[];

          // recarr=this.selectedVendor;
          const Obj={
               brand_id: 621,
              // brand_id: userInfo[0].brand_assign,
              style_id: this.$route.params.id
          }
        //   style_id->143
        // agentmaster
        axios.post(`${CONSTANTS.API_URL}/getvendorlist`,Obj)
          .then((result) => {
            // document.getElementById("overlay").style.display = "none";
            // this.vendor_msg = result.body.returnmsg;
            // this.agentmaster = result.body.returnvalue;
            this.vendor_list = result.body.returnvalue;
            console.log("UUUUUUUUUUUUUUUUUUUUU", this.vendor_list[0].vendor_name);
            // this.selected_vendor = this.vendor_list.returnvalue[0].vendor_name
        //     console.log("VVVVVVVVVVVVVVVVVVVVVV",this.selected_vendor);
        //      for(var i = 0; i < this.agentmaster.length; i++) {
        //       var vendoryagent2 = {
        //   id: this.agentmaster[i].vendor_id
        // }
        // this.vendor_options.push(this.agentmaster[i].vendor_id);
             
        //  }
         

          })
          .catch((ex) => {
            console.log('error', ex)
          })
        },
       //Vendor list
               /*******Function for Vendor List********/
      displayvendorlist: function(){
        // alert("In");
        // document.getElementById("overlay").style.display = "block";
        // var userdata = localStorage.getItem('userData')
        // var userInfo = JSON.parse(userdata)
        // var recarr=[];

        //   // recarr=this.selectedVendor;
        //   const Obj={
        //        //brand_id: 621,
        //        brand_id: userInfo[0].brand_assign,
        //       style_id: this.$route.params.id
        //   }
          // style_id->143
        //agentmaster
        // axios.post(`${CONSTANTS.API_URL}/getvendorlist`,Obj)
        //   .then((result) => {
        //     // document.getElementById("overlay").style.display = "none";
        //     // this.vendor_msg = result.body.returnmsg;
        //     // this.agentmaster = result.body.returnvalue;
        //     this.vendor_list = result.body.returnvalue;
        //     this.selected_vendor = this.vendor_list.returnvalue[0].vendor_name
        //      for(var i = 0; i < this.agentmaster.length; i++) {
        //       var vendoryagent2 = {
        //   id: this.agentmaster[i].vendor_id
        // }
        // this.vendor_options.push(this.agentmaster[i].vendor_id);
             
        //  }
         

        //   })
        //   .catch((ex) => {
        //     console.log('error', ex)
        //   })
    },
       //vendor list ends 

       /****** Function to design details ********/
       getdesigndetail: function () {
        
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,              
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            // document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.selected_brand_id = this.style_details.brand_id; 
            
            this.displayvendorlist(this.style_details.brand_id);             
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },


       /*******Function for Vendor List********/
    //   displayvendorlist: function(brand_id) {
    //     var userdata = localStorage.getItem('userData')
    //     var userInfo = JSON.parse(userdata)
    //       const Obj={
    //           style_id: this.$route.params.id
    //       }
    //     axios.post(`${CONSTANTS.API_URL}/getmessagevendorlist`,Obj)
    //       .then((result) => {
    //         this.vendor_list = result.body.returnvalue;
            

    //       })
    //       .catch((ex) => {
    //         console.log('error', ex)
    //       })
    // },


        messagedisplay: function (value) {
          this.selected_vendor = value;
          var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
 
          
            const Obj={
              // user_id: userInfo[0].user_id,
              // vendor_id: this.selected_vendor,
              // user_id:userInfo[0].user_id,
              user_id: 579,
              vendor_id:value,
              style_id: this.$route.params.id
              // style_id: this.$route.params.id,
            } 
            
            // this.isBusy = true;
            axios.post(`${CONSTANTS.API_URL}/getmessages`,Obj)
            .then(response => {
              this.result = response.data
              if (this.result.returnmsg === 'Successful') {
                console.log("PPPPPPPPPPPPPPPPPPP",this.result.returnvalue)
                this.messagedata  = this.result.returnvalue;
                this.returnmsg_data = this.result.returnmsg;
                this.totalRows = this.result.returnvalue.length;

                // this.availablevendors();
                //this.messages.push(message);
                this.isBusy = !this.isBusy;

                // this.availablevendors();
                

            //     setTimeout(() => {
            //     message.uploaded = true
            // }, 2000)
                
              }else {

               this.returnmsg_data = this.result.returnmsg;
               this.totalRows= 0;
               this.availablevendors();
                this.isBusy = !this.isBusy;
              }


            })
            .catch(e => {
              this.errors.push(e)
            }) 
        },

        onMessageSubmit: function (value) {
            var userData = localStorage.getItem('userData');
             console.log('jjj',userData);
          var userInfo = JSON.parse(userData)
          // alert("Inn");
            const Obj={
              vendor_id: value,
              // user_id: userInfo[0].user_id,
              user_id: 579,
              message: this.txtInput,
              message_by: 0,
              style_id:this.$route.params.id 
            }
            // this.isBusy = true;
            axios.post(`${CONSTANTS.API_URL}/updatemessage`,Obj)
            .then(response => {
              this.result = response.data
              if (this.result.returnmsg === 'Successful') {
                console.log("TTTTTTTTTTTTTTTTT",this.result.returnvalue);
                this.updateddata  = this.result.returnvalue;
                this.totalRows = this.result.returnvalue.length;
                this.txtInput ='';
                this.selectedId=this.updateddata[0].vendor_id;
                this.messagedisplay(this.selectedId);
                //this.messages.push(message);
                this.isBusy = !this.isBusy;
                

            //     setTimeout(() => {
            //     message.uploaded = true
            // }, 2000)
                
              }else {
               this.updateddata =[];
               this.totalRows=0;
                this.isBusy = !this.isBusy;
              }


            })
            .catch(e => {
              this.errors.push(e)
            }) 
        },
       //Added Message Code Ends
   
     }
   };
</script>
<style>
   .short-div {
   height:55px;
   }


.quote-dropdowns .dropdown--accepted {
    border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns>.card {
    background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}
.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
    align-items: center;
    justify-items: center;
    justify-content: center;
    cursor: pointer;
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}
.f-sz-l {
    font-size: 15px;
}
.flex-col {
    flex-direction: column;
}
.flex, .flex-col {
    display: flex;
}
.f-w-semi-bold {
    font-weight: 600;
}
.f-sz-sm {
    font-size: 12px;
}
.f-w-semi-bold {
    font-weight: 600;
}   

.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}

.input-grp {
    width: 100%;
    margin-bottom: 16px;
}
.input-grp {
    margin-bottom: 10px!important;
}

.input-grp label {
    margin-bottom: 6px;
    color: #333340;
}

input[type=number], input[type=password], input[type=tel], input[type=text] {
    padding: 13px 12px;
    border-radius: 2px;
    border: 1px solid #bfbfbf;
}
.input-grp input, .input-grp label, .input-grp select {
    display: block;
    width: 100%;
}

.input-grp select:disabled {
    background-color: #ebebe4;
}
.input-grp select {
    background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
    background-position: right 8px top 6px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}


  
    .main_body{
      width: 970px;
    }
   /*.card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;

  }*/
    .container{
      align-content: center;
    }
    .search{
      border-radius: 15px 0 0 15px !important;
      background-color: white !important;
      border:0 !important;
      color:white !important;
    }
    .search:focus{
         box-shadow:none !important;
          outline:0px !important;
    }
    /*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
      #type_msg:focus{
         box-shadow:none !important;
           outline:0px !important;
    }
    .send_btn{
      border:1 !important;
      border-color: #20a8d8;
      background-color: #4d94ff;
      cursor: pointer;
    }
    .search_btn{
      border-radius: #20a8d8 !important;
      border:0 !important;
      background-color: #20a8d8;
      cursor: pointer;
    }
    .contacts{
      list-style: none;
      padding: 0;
    }
    .contacts li{
      width: 100% !important;
      padding: 5px 10px;
      margin-bottom: 15px !important;
    }
 
    .user_img{
      height: 40px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: 10px;

    }
    .user_img_msg{
      height: 30px;
      width: 30px;
      border:1.5px solid #f5f6fa;
    
    }
  .text-span{
    background:blue;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}
.text-span2{
    background:gray;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}

  /*.mb-4, .my-4 {
    margin-bottom: 0.5rem !important;
    position: absolute;
    top: 65px;
  }*/
 /* #vendor_name{
    font-size: 16px;
    color: black;
    font-style: normal
  }*/


  .msg_time_send{
    position: absolute;
    right:0;
    bottom: -15px;
    color: rgba(255,255,255,0.5);
    font-size: 10px;
  }
  .msg_head{
    position: relative;
  }
  .brandcard{
   border-radius:0px !important;
   padding-left: 10px !important;
  }

     .sidebar{
   background: #17a2b8!important;
   width:50px !important;
   }

   .sidebar .sidebar-nav{
    width:50px !important;
   }
   .sidebar .nav{
    width:50px !important;
   }

   .main1{
    margin-left:50px !important;
   }
   #rec_msg{    
    margin-left: 40%;
    position: absolute;
   }

   /*****CSS For Zoom Image*****/
   *body {
  margin: 0;
}
#btn_navbar {
  overflow: hidden;
  text-align: center;
  /*position: fixed;*/
  top: 0;
  width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 20px;
}
#btn_navbar a {
  float: left;
  display: block;
  color: #666;
  text-align: center;
  padding-right: 20px;
  text-decoration: none;
  font-size: 17px;
}
#btn_navbar a:hover {
  background-color: #ddd;
  color: black;
}
#btn_navbar a.active {
  background-color: #4CAF50;
  color: white;
}
.main1 {
  padding: 16px;
  margin-top: 30px;
}
.main1 img {
  max-width: 100%;
  height: auto;

}
.button {
  width: 300px;
  height: 60px;
}

   /*****CSS For Zoom Image Ends*****/


/*** Tabb ***/
/*.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
    width: 100%;
}
.flex {
    display: flex;
}*/

/*.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 60px;
    padding: 12px 24px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border:1px solid gray;
}*/

/*.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;

    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
}*/ 



html, body {
  margin: 0
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color:white
}
.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 43px !important;
    padding: 12px 22px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border: 1px solid #63c2de;
    border-radius: 12px;
}



/*Todays CSS*/
.nav_row_tabs {
 
  display: flex;
  border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;
}


  .nav_tabs__tab--disabled {
    cursor: not-allowed!important;
    opacity: .6;
    pointer-events: none; 
}

  /*CSS 2710*/
  .nav_tabs__tab--active:after {
    background: var(--fill-primary-blue);

}

  .nav_tabs__tab-image {
    padding-right: 8px;
}
.nav_tabs__tab-block {
    display: flex;

    flex-direction: column;
    justify-content: center;
}
.nav_tabs__tab-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.nav_tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid #D7DBDD;
}
#activeTitle{
  font-size: 14px;
}
.viewClass{
  width: 190px;
}
.swal2-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
}
.selectedcolor{
  padding:5px;
  text-align:center;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: rgb(255,255,255);
  /*background-color: rgb(119 119 119);*/
  background-color: rgba(255,255,255, 1);
  /*background-color: rgb(119 119 119,0.9);*/
  overflow-y: hidden;
  overflow:auto;
  transition: 0.5s;
}
.overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 60px;
  color: #16A2D7;
}
.overlay-content {
  position: relative;
  top: 11%;
  right: 15px;
  width: 100%;
  text-align: center;
  margin-top: 30px;
  color:#bbbaba;
}
/*.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}*/
.overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 18px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.overlay a:hover, .overlay a:focus {
  color: #0864d6;
}
.design-list__item1 {
    height: 67px;
    padding: 12px 20px;
    padding-right: 6px;
    /*border-bottom: none !important;*/
    cursor: pointer;
}
.imgsidedesign{
  width: 20%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
@media screen and (max-width: 1170px) {
  .side{
    display: none;
  }

}
@media screen and (min-width: 1170px) {
  .navbtn{
    display: none;
  }
 
}
@media screen and (min-width: 1170px) {
  .closebtn{
    display:none;
  }
 
}
@media screen and (min-width: 320px) {
  .overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 15px;
  left: 0;
  background-color: rgb(255,255,255);
  /*background-color: rgb(119 119 119);*/
  background-color: rgba(255,255,255, 1);
  /*background-color: rgb(119 119 119,0.9);*/
  overflow-y: hidden;
  overflow:auto;
  transition: 0.5s;
}
  .overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 30px;
  color: #16A2D7;
}
.overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 9px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.f-sz-sm{
  font-size:8px;

}
.design-list__subtitle1{
  margin-left: 25px;
  border-bottom: 1px solid #e4e4e4;
}
.design-list__item1 {
    height: 56px;
    padding: 10px 21px;
    padding-right: 6px;
    border-bottom: 1px solid #d4d4d4;
    cursor: pointer;
}

.imgsidedesign{
  width: 61%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
.design-list__title1{
  margin-left: 25px;
}
 
}
@media screen and (min-width: 411px and min-width: 414px) {
  .overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 15px;
  left: 0;
  background-color: rgb(255,255,255);
  
  background-color: rgba(255,255,255, 1);
  
  overflow-y: hidden;
  overflow:auto;
  transition: 0.5s;
}
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 11px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.design-list__subtitle1{
  border-bottom: 1px solid #e4e4e4;
}
.imgsidedesign{
  width: 61%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
 
}
 @media screen and (min-width: 1024px) {
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 16px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 45px;
  color: #16A2D7;
}
.design-list__title1{
  margin-left: 55px;
  margin-bottom: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
}
.design-list__subtitle1{
  
  border-bottom: 1px solid #e4e4e4;
}
.imgsidedesign{
  width: 20%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
 
}
@media screen and (min-width: 768px) {
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 16px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 45px;
  color: #16A2D7;
}
.design-list__title1{
  margin-left: 55px;
  margin-bottom: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
}
.design-list__subtitle1{
  
  border-bottom: 1px solid #e4e4e4;
}
.imgsidedesign{
  width: 30%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
 
}


.designtitle{
  margin-top:0.625em;
  margin-bottom:0.625em;
  width: 85%;
}
.dropdowndesign{
  float: right !important;
  margin-right: 0.625em !important;
}
.divdesign{
  float: left;
  border: 1px solid lightgray;
}
.imgdesign{
  padding:  0.3125em;
  height:13.75em;
  width: 21.8125em;
}
.btndesign{
  padding:0.3125em;
  margin-left: 30%;
}
.stylefield{
  font-size: 0.9375em !important;   
}
@media (min-width: 576px)
{
.navbar-expand-sm {
    flex-flow: row wrap;
    justify-content: flex-start;
}
}
@media (max-width: 320px)
{
  .designtitle{
    /* margin-top:10px;
  margin-bottom:10px;*/
  width: 80%;
  font-size:8px;
  padding: 5px;
  }
  .imgdesign{
    width: 90px;
    height: 80px;
  }
  .btndesign{
  padding:1px;
  font-size:9px;
  margin-top: 3px;
  margin-left:25px;
  
}
.divdesign{
  float: left;
  border: 1px solid lightgray;
  height: 110px;
  margin-top: -50px;
  margin-bottom: 10px;
}
.stylefield{
  font-size: 10px !important;   
}
  .coldesign{
    flex: 0 0 100% !important;
    max-width: 85% !important;
}
.detailsrow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}
.selectedcolor{
  padding:5px;
  text-align:center;
  width:50%;
}

/*.colonb{
  text-align: center;
  position: absolute;
  
}
.titleb{
   position: absolute;
   width: 60%;
   
}*/
}
@media (max-width: 360px)
{
  .designtitle{
    /* margin-top:10px;
  margin-bottom:10px;*/
  width: 90% !important;
  font-size:10px !important;
  padding: 5px !important;
  }
  .imgdesign{
    width: 90px !important;
    height: 80px !important;
  }
  .btndesign{
  padding:2px !important;
  font-size:9px !important;
  margin-top: 3px !important;
  margin-left:15px !important;
  
}
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 110px !important;
  margin-top: -50px !important;
  margin-bottom: 5px !important;
  margin-left:1px !important;
}
.brandcard {
    padding-left: 12px !important;
}
.dropdowndesign{
  float: right !important;
  margin-right: 10px !important;
}
/*.stylefield{
  font-size: 11px !important;

    padding: 0px !important;
}*/
.coldesign{
    flex: 0 0 100% !important;
    max-width: 86% !important;
}
.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}
.colonb{
  text-align: center !important;
  position: absolute !important;
  margin-left: 10px !important;
}
.titleb{
   position: absolute !important;
    margin-left: 50% !important;
}

}
@media (max-width: 280px)
{
  .designtitle{
    /* margin-top:5px;
  margin-bottom:5px;*/
  width: 70% !important;
  font-size:9px !important;
  /*padding: 10px !important;*/
  }
  .imgdesign{
    width: 80px !important;
    height: 60px !important;
  }
  .btndesign{
  padding:3px !important;
  font-size:9px !important;
  margin-top: 5px !important;
  margin-left:9px !important;
  
}
/*.divdesign{
  float: left;
  border: 1px solid lightgray;
  height: 95px !important;
}*/
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 95px !important;
  margin-top:-50px !important;
  margin-bottom:5px !important;
}
/*.brand-card {
    padding-left: 10px !important;
}*/
.dropdowndesign{
  /*float: right;*/
  margin-right: 10px !important;
  /*margin-bottom:10px;*/
}
.stylefield{
  font-size: 10px !important;
    padding: 0px !important;
}
.coldesign{
    flex: 0 0 104% !important;
    max-width: 105% !important;
}
.detailsrow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}
.selectedcolor{
  padding:1px;
  text-align:center;
  width:50%;
}


}
@media (max-width: 450px) and (min-width: 350px) 
{
  .designtitle{
     /*margin-top:5px;
  margin-bottom:5px;*/
  width: 80% !important;
  font-size:10px !important;
  padding: 10px !important;
  }
  .imgdesign{
    width: 120px !important;
    height: 90px !important;
  }
  .btndesign{
  padding:4px !important;
  font-size:10px !important;
  margin-top: 5px !important;
  margin-left:25px !important;
  
}
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 130px !important;
  margin-top:-50px !important;
  margin-bottom:10px !important;
}
.brandcard {
    padding-left: 15px !important;
}
.dropdowndesign{
  float: right !important;
  margin-right: -34px !important;
  margin-bottom:10px !important;
}
.stylefield{
  font-size: 10px !important;
    padding: 0px !important;
    margin-left: -16px !important;
}
/*.coldesign{
    flex: 0 0 50% !important;
    max-width: 100% !important;
}*/
.coldesign{
    flex: 0 0 100% !important;
    max-width: 85% !important;
}
/*.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}*/
.colonb{
  text-align: center !important;
  position: absolute !important;
  margin-left: 10px !important;
}
.titleb{
   position: absolute !important;
    margin-left: 50% !important;
}
.detailsrow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}
.selectedcolor{
  padding:5px;
  text-align:center;
  width:50%;
}



}
@media (max-width: 540px) and (min-width: 450px)
{
  .designtitle{
     /*margin-top:5px;
  margin-bottom:5px;*/
  width: 80% !important;
  font-size:13px !important;
  padding: 10px !important;
  }
  .imgdesign{
    width: 150px !important;
    height: 120px !important;
  }
  .btndesign{
  padding:4px !important;
  font-size:10px !important;
  margin-top: 5px !important;
  margin-left:35px !important;
  
}
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 160px !important;
  margin-top:-50px !important;
  margin-bottom:10px !important;
}
/*.brandcard {
    padding-left: 15px !important;
}*/
.detailsrow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}
.dropdowndesign{
  float: right !important;
  margin-right: -10px !important;
  margin-bottom:5px !important;
}
.stylefield{
  font-size: 13px !important;
    padding: 0px !important;
    margin-left: -16px !important;
}
/*.coldesign{
    flex: 0 0 50% !important;
    max-width: 100% !important;
}*/
.coldesign{
    flex: 0 0 100% !important;
    max-width: 85% !important;
}
/*.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}*/
.colonb{
  text-align: center !important;
  position: absolute !important;
  margin-left: 10px !important;
}
.titleb{
   position: absolute !important;
    margin-left: 50% !important;
}

.selectedcolor{
  padding:5px;
  text-align:center;
  width:50%;
}

}
/*@media (max-width: 360px)
{
  
}*/
@media (max-width: 768px)and (min-width:550px) 
{
  .designtitle{
  /*   margin-top:5px !important;
  margin-bottom:5px !important;*/
  width: 80% !important;
  font-size:17px !important;
  padding: 10px !important;
  }
  .imgdesign{
    width: 220px !important;
    height: 150px !important;
  }
  .btndesign{
  padding:4px !important;
  font-size:10px !important;
  margin-top: 5px !important;
  margin-left:70px !important;
  
}
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 190px !important;
  margin-top:-40px !important;
  margin-bottom: 10px !important;
  margin-left: 40px !important;
}
/*.brand-card {
    padding-left: 15px !important;
}*/
.dropdowndesign{
  float: right;
  margin-right: 5px !important;
  /*margin-bottom:10px !important;*/
}
.stylefield{
  font-size: 15px !important;
    padding: 0px !important;
    margin-left: 30px !important;
}
.coldesign{
    flex: 0 0 85% !important;
    max-width: 100% !important;
}

}
@media (max-width: 700px)
{
  .designtable{
    display:none;
  }
}

@media (min-width: 700px)
{
  .tablebtn{
    display:none;
  }
}
@media (max-width: 375px) and (min-width:350px) 
{
  .tdhead{
   font-size:8px;
  }
  .tdsize{
    font-size:8px
  }
  .tdunit{
    font-size: 12px;
    width: 35px;
    padding: 2px;
  }
  .tdageform{
    padding: 2px;
    font-size: 13px;
    width: 40px;
  }
  .tdageto{
    padding: 2px;
    width: 40px;
    font-size: 13px;
  }
  .tdfactory{
    padding: 7px !important;
    font-size: 12px !important;
    width: 35px !important;
    height: 23px !important;
  }
 .tdquantity{
    padding: 7px !important;
    font-size: 12px !important;
    width: 36px !important;
    height: 23px !important;
 }
 .tabset{
  margin-left:-13px;
 
  
 }
}
@media (max-width: 320px)
{
 .tabset{
  margin-left:-9px;
  overflow:auto;
  
 }
}
@media (max-width: 300px)
{
 .tabset{
  margin-left:-9px;
  overflow:auto;
 }
}
@media (max-width: 450px)
{
 .tdhead{
  font-size:10px !important;
 }
 .tdsize{
    font-size:10px !important;
  }
  .tdunit{
    padding: 3px !important;
    font-size: 15px !important;
    width: 40px !important;
     height: 27px !important;
  }
  .tdageform{
    padding: 2px !important;
    font-size: 13px !important;
    width: 42px !important;
     height: 27px !important;
  }
  .tdageto{
   padding: 2px !important;
    font-size: 13px !important;
    width: 42px !important;
     height: 27px !important;
  }
  .tdfactory{
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
 .tdquantity{
     padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
 }

}
@media (max-width: 540px) and (min-width:500px) 
{
  .tdunit{
    padding: 5px !important;
    font-size: 15px !important;
    width: 45px !important;
     height: 32px !important;
  }
  .tdageform{
   padding: 1px !important;
    width: 40px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
  .tdageto{
   padding: 1px !important;
    width: 40px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
  /*.tdfactory{
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
 .tdquantity{
     padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
 }*/
}
@media (max-width: 1040px)
{
 .detailside{
  display:none;
 }
}
</style>
